export function populateNodeData({
  workflow,
  setWorkflow,
  nodeId,
  setFormField,
  setFetchedHeader,
  setHeaderName,
  setFilterCol,
  setAttributes,
  setAddClause,
  setHeaderRow,
  setCount,
  setAggregate,
  setGroupBy,
  setToggleType,
  setSortingCol,
  setIsCopilotData,
}) {
  setTimeout(() => {
    if (workflow.copilotOpen && workflow.copilotAddedPipeline?.length > 0) {
      workflow.copilotAddedPipeline.some((item, index) => {
        if (item.status === 'completed') {
          return item.pipeline.some((pipeline, p_index) => {
            const allNodes = JSON.parse(sessionStorage.getItem('allNodes')) || [];
            const exists = allNodes.some((node) => node.nodeId === nodeId);
            if (!exists) {
              if (nodeId === pipeline.currentNode.nodeId 
                // && !pipeline.isDataPopulated
              ) {
                const formData = pipeline.formData;

                if (!formData || !formData.formField) return false;

                setFormField((prev) => ({
                  ...prev,
                  ...formData.formField,
                }));

                if (Array.isArray(formData.headerName)) {
                  const tableData = formData.headerName.map((item) => ({
                    ...item,
                    alias: '',
                    tableAlias: formData.formField.alias,
                    cast_datatype: 'string',
                    default_value: '',
                    attribute_type: 'static',
                  }));

                  const checkedTableData = tableData.filter((item) => item.checked === 'true');

                  if (typeof setFetchedHeader === 'function') {
                    setFetchedHeader(tableData);
                  }

                  if (typeof setHeaderName === 'function') {
                    setHeaderName(checkedTableData);
                  }
                }

                if (typeof setFilterCol === 'function') {
                  setFilterCol(formData.sorting);
                }

                if (typeof setAttributes === 'function') {
                  setAttributes(formData.attributes);
                }

                if (typeof setAddClause === 'function') {
                  setAddClause(formData.addClause);
                }

                if (typeof setHeaderRow === 'function') {
                  setHeaderRow(formData.onRow);
                }

                if (typeof setCount === 'function') {
                  setCount(formData.count);
                }

                if (typeof setAggregate === 'function') {
                  setAggregate(formData.aggregate);
                }

                if (typeof setGroupBy === 'function') {
                  setGroupBy(formData.groupBy);
                }

                if (typeof setToggleType === 'function') {
                  setToggleType(formData.toggleType);
                }

                if (typeof setSortingCol === 'function') {
                  setSortingCol(formData.sorting);
                }

                if (typeof setIsCopilotData === 'function') {
                  setIsCopilotData(true);
                }

                // setWorkflow((prev) => ({
                //   ...prev,
                //   copilotAddedPipeline: prev.copilotAddedPipeline.map((item, i) => {
                //     if (i === index) {
                //       return {
                //         ...item,
                //         pipeline: item.pipeline.map((pl, j) => {
                //           if (j === p_index) {
                //             return { ...pl, isDataPopulated: true }; // ✅ updated
                //           }
                //           return pl;
                //         }),
                //       };
                //     }
                //     return item;
                //   }),
                // }));

                return true; // ✅ Found matching node
              }
            }
            return false;
          });
        }
        return false;
      });
    }
  }, 0);
}
